import { createUseData } from "../../../../common/hooks/create-use-data/create-use-data";
import { service } from "./admin-user.service";

export const useAdminUser = createUseData(
    service.getAdminUser,
)